import Meal from './Meal'

const Meals = ({ meals, toggleMealCard, setFavorite}) => {

return (
    <div>
        {meals.map((meal) => (
            <Meal key={`meal-${meal.id}`} meal={meal} toggleMealCard={toggleMealCard} setFavorite={setFavorite}></Meal>
        ))}
    </div>
)
}

export default Meals
